import store from '@/store'
import { deepClone } from '@/utils'

export default {
  created() {
    const name = this.$options.name
    console.log('created ->' + name)
    if (store.getters.dataCahce && store.getters.dataCahce.hasOwnProperty(name)) {
      console.log('created', name, store.getters.dataCahce[name])
      this.queryRequest = store.getters.dataCahce[name];
    }

  },
  mounted () {
    // if (this.hasOwnProperty('multipleSelection') && this.batchModifyFlag && this.multipleSelection.length > 0) {
    //   this.setSelectRow()
    // }
  },
  destroyed(){
    const name = this.$options.name
    console.log('destroyed', name)
    if(this.$data.queryRequest){
      //深度拷贝内容太多，会导致堆栈溢出，暂未找到解决方法，故先拷贝列表请求参数（固定该字段：queryRequest） 刷新页面会清空缓存
      store.dispatch('setDataCache',{
        name: name,
        data: deepClone(this.$data.queryRequest)
      })
    }

  }
}
